import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Tabs, TabsProps } from 'antd/es';

interface AreaPageMobileNavProps {
	currentAreaUrl: any;
	activeTab: string;
	additionalClass: string
}

const tabs: TabsProps['items'] = [
	{
		key: 'about',
		label: 'About',
	},
	{
		key: 'services',
		label: 'Pricing & Services',
	},
	{
		key: 'veterinarians',
		label: 'Veterinarians',
	},
	{
		key: 'resources',
		label: 'Local Resources',
	},
	{
		key: 'keepsakes',
		label: 'Pet Memorial Keepsakes',
	},
];

const AreaPageMobileNav: React.FC<AreaPageMobileNavProps> = ({ currentAreaUrl, activeTab, additionalClass }) => {
	const navigate = useNavigate();

	return (
		<Tabs
			className={additionalClass ? `top-page__mobile-nav ${additionalClass}` : 'top-page__mobile-nav'}
			defaultActiveKey="1"
			onTabClick={(key, event) => {
				navigate(`${currentAreaUrl}/${key}`);
			}}
			activeKey={activeTab}
			items={tabs}
		/>
	);
};

export default AreaPageMobileNav;
